import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicDetailsService {
  public saveDetailsSubmitted = new Subject();
  public formIsDirty: boolean = false;
  public detailsChanged = new BehaviorSubject<boolean>(false);
  public detailsSaveEnabled = new BehaviorSubject<boolean>(true);
  public markAsPristine = new Subject<boolean>();

  constructor() {}

  saveDetails() {
    this.saveDetailsSubmitted.next();
    this.markAsPristine.next();
    this.formIsDirty = false;
  }
}
